import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoharihareshwarcab() {



    const cardData = {

keyword: "Pune to Harihareshwar Cabs",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Harihareshwar Cabs for families, couples, and weekend travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth journey from Pune to the Konkan coast. Our service includes doorstep pickup, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a relaxing and scenic travel experience to Harihareshwar beach and temple destination.",

topPlaces: [
    {
        title: "Harihareshwar Beach",
        description:
            "Harihareshwar Beach is a calm and clean coastal destination surrounded by hills on both sides, making it one of the most scenic beaches in Konkan. The peaceful shoreline, gentle waves, and less crowded environment make it ideal for relaxation, photography, and family outings. It is especially beautiful during sunrise and sunset when the sea reflects golden colors across the horizon."
    },
    {
        title: "Shri Harihareshwar Temple",
        description:
            "Shri Harihareshwar Temple is an ancient and highly revered Shiva temple often called the ‘Dakshin Kashi’. Located very close to the beach, it is surrounded by green hills and spiritual energy. Devotees visit this temple for blessings, peace of mind, and religious significance during Konkan pilgrimage tours."
    },
    {
        title: "Harihareshwar Cliff Walk",
        description:
            "The Harihareshwar cliff walk offers breathtaking views of the Arabian Sea, rocky cliffs, and lush greenery. It is one of the most scenic experiences in the region, ideal for photography, nature walks, and enjoying cool sea breezes along the coastline."
    },
    {
        title: "Diveagar Beach (Nearby)",
        description:
            "Diveagar Beach is a peaceful and clean beach near Harihareshwar known for its long shoreline, coconut trees, and calm environment. It is less commercialized, making it perfect for relaxing vacations, quiet walks, and enjoying untouched Konkan beauty."
    },
    {
        title: "Shrivardhan Beach",
        description:
            "Shrivardhan Beach is a beautiful coastal destination near Harihareshwar with soft sand, gentle waves, and a relaxed atmosphere. It is part of the popular Harihareshwar–Shrivardhan coastal belt and is ideal for peaceful beach holidays and family trips."
    },
    {
        title: "Bankot Fort",
        description:
            "Bankot Fort is a historic Maratha-era fort located near the Savitri River estuary. It offers panoramic views of the sea, river, and surrounding landscapes. The fort is a great spot for history lovers and travelers interested in coastal heritage."
    },
    {
        title: "Bagmandla Ferry Point",
        description:
            "Bagmandla is an important ferry connection point near Harihareshwar that connects coastal villages and routes across the Savitri River. It reflects traditional Konkan lifestyle and provides scenic views of backwaters and mangroves."
    },
    {
        title: "Savitri River Estuary",
        description:
            "The Savitri River estuary near Harihareshwar is where the river meets the Arabian Sea, creating a peaceful natural landscape with mangroves, calm waters, and scenic beauty. It is ideal for photography and nature observation."
    },
    {
        title: "Velas Turtle Beach (Nearby)",
        description:
            "Velas Beach is famous for its Olive Ridley turtle conservation project and seasonal turtle hatching events. It is an eco-tourism destination near Harihareshwar attracting nature lovers and wildlife enthusiasts during specific months."
    },
    {
        title: "Konkan Coastal Highway Route",
        description:
            "The Pune to Harihareshwar route via the Konkan coastal highway offers a scenic journey through the Western Ghats, forests, rivers, and coastal landscapes. The drive itself is a major highlight of the trip, making cab travel enjoyable and memorable."
    }
],



services: [
  {
    name: "Pune to Harihareshwar Cab",
    description: "Rising Cab Service offers reliable Pune to Harihareshwar Cab service for a safe, scenic, and comfortable coastal journey to the beautiful Harihareshwar beach and temple destination. Ideal for families, couples, and group travelers, we provide well-maintained AC vehicles, experienced long-distance drivers, doorstep pickup from Pune, flexible travel timing, and 24x7 support. Enjoy a smooth highway ride through Konkan routes with complete comfort, transparent pricing, and a stress-free travel experience."
  },
  {
    name: "Pune to Harihareshwar Taxi",
    description: "Book Pune to Harihareshwar Taxi with Rising Cab Service for a comfortable and reliable long-distance journey to one of Maharashtra’s serene beach and temple destinations. We offer clean sanitized vehicles, professional chauffeurs, and safe driving across highways and coastal roads. Perfect for weekend trips, religious visits, and family holidays with flexible pickup and drop options."
  },
  {
    name: "Cab from Pune to Harihareshwar",
    description: "Hire Cab from Pune to Harihareshwar for convenient door-to-door travel with complete flexibility and comfort. Choose from sedans, SUVs, and Innova Crysta depending on your group size. Our experienced drivers ensure safe travel through scenic Konkan routes with smooth rides, planned stops, and complete travel assistance."
  },
  {
    name: "Taxi from Pune to Harihareshwar",
    description: "Taxi from Pune to Harihareshwar service ensures punctual pickup, professional driving, and a safe long-distance journey to the coastal temple town. Ideal for beach vacations and pilgrimage trips, our taxis provide AC comfort, affordable pricing, and reliable service throughout the trip."
  },
  {
    name: "Pune to Harihareshwar Cab Service",
    description: "Our Pune to Harihareshwar Cab Service provides complete travel solutions including pickup, drop, sightseeing flexibility, and return options. We focus on safety, comfort, and affordability with trained drivers, well-maintained vehicles, and 24x7 booking assistance for a smooth Konkan journey."
  },
  {
    name: "Pune to Harihareshwar Taxi Fare",
    description: "Get transparent Pune to Harihareshwar Taxi Fare with clear and affordable pricing based on vehicle type and travel plan. We offer budget-friendly and premium options for sedans, SUVs, and Innova Crysta with no hidden charges, ensuring value-for-money travel for long coastal routes."
  },
  {
    name: "Pune to Harihareshwar One Way Cab",
    description: "Book Pune to Harihareshwar One Way Cab for economical drop-only travel to the scenic Konkan coast. Ideal for solo travelers, couples, and families, this service includes AC vehicles, professional drivers, and smooth highway travel at affordable rates without return charges."
  },
  {
    name: "Pune to Harihareshwar Round Trip Taxi",
    description: "Pune to Harihareshwar Round Trip Taxi service is perfect for weekend beach vacations and temple visits. It includes flexible return scheduling, waiting time, comfortable vehicles, and experienced drivers for a complete round-trip travel experience."
  },
  {
    name: "Pune to Harihareshwar Cab Booking",
    description: "Easy Pune to Harihareshwar Cab Booking system for instant reservations with multiple vehicle choices including Sedan, SUV, Innova Crysta, and Tempo Traveller. Get quick confirmation, transparent pricing, and 24x7 customer support for a seamless travel experience."
  },
  {
    name: "Cheap Pune to Harihareshwar Cab",
    description: "Affordable Cheap Pune to Harihareshwar Cab service for budget travelers who want economical yet safe coastal travel. We provide low-cost fares, clean vehicles, and professional drivers without compromising comfort or safety."
  },
  {
    name: "Best Pune to Harihareshwar Taxi",
    description: "Choose Best Pune to Harihareshwar Taxi service for premium travel experience with top-rated drivers, comfortable vehicles, and smooth highway driving through scenic Konkan routes."
  },
  {
    name: "Sedan Pune to Harihareshwar Cab",
    description: "Sedan Pune to Harihareshwar Cab service is ideal for solo travelers, couples, and small families seeking budget-friendly and comfortable long-distance travel."
  },
  {
    name: "SUV Pune to Harihareshwar Taxi",
    description: "Book SUV Pune to Harihareshwar Taxi for group travel requiring extra space and comfort. Our SUVs are perfect for Konkan routes, offering smooth rides and strong performance."
  },
  {
    name: "Innova Pune to Harihareshwar Cab",
    description: "Premium Innova Pune to Harihareshwar Cab service for families and groups seeking luxury, comfort, and spacious seating for long coastal journeys."
  },
  {
    name: "Beach Cab Pune Harihareshwar",
    description: "Beach Cab Pune Harihareshwar service is specially designed for tourists visiting Harihareshwar beach and temple. Enjoy scenic coastal drives, flexible stops, and comfortable AC vehicles."
  },
  {
    name: "Pune to Harihareshwar Innova Taxi",
    description: "Pune to Harihareshwar Innova Taxi service offers premium comfort for families and groups with spacious seating and smooth long-distance travel experience."
  },
  {
    name: "Pune to Harihareshwar Tour Package",
    description: "Complete Pune to Harihareshwar Tour Package including pickup, beach visits, temple darshan, sightseeing, and return journey for a hassle-free coastal vacation."
  },
  {
    name: "Harihareshwar Cab from Pune",
    description: "Harihareshwar Cab from Pune service offers direct door-to-door travel to the beach and temple destination with safe driving and flexible travel plans."
  },
  {
    name: "Pune to Harihareshwar Online Cab Booking",
    description: "Easy Pune to Harihareshwar Online Cab Booking system for instant reservations, transparent pricing, and multiple vehicle options for smooth travel planning."
  },
  {
    name: "Pune to Harihareshwar Tourist Cab Service",
    description: "Pune to Harihareshwar Tourist Cab Service provides complete travel solutions for tourists exploring beaches, temples, and Konkan attractions."
  },
  {
    name: "Pune to Harihareshwar Temple Darshan Cab",
    description: "Pune to Harihareshwar Temple Darshan Cab service ensures smooth and peaceful travel for devotees visiting the temple with professional drivers and reliable vehicles."
  },
  {
    name: "Pune to Harihareshwar Travel Package",
    description: "Pune to Harihareshwar Travel Package includes complete travel planning with pickup, sightseeing, beach visits, and return journey for a comfortable trip."
  },
  {
    name: "Pune to Harihareshwar Long Distance Taxi",
    description: "Pune to Harihareshwar Long Distance Taxi service ensures safe, comfortable, and reliable highway travel with experienced drivers and well-maintained vehicles."
  },
  {
    name: "Pune to Harihareshwar Door to Door Cab",
    description: "Pune to Harihareshwar Door to Door Cab service provides convenient pickup and drop from your exact location for a hassle-free travel experience."
  },
  {
    name: "Pune to Harihareshwar Holiday Package",
    description: "Pune to Harihareshwar Holiday Package offers complete travel solutions for weekend and holiday trips with sightseeing and comfortable cab service included."
  }
],

tableData: [
  ["Pune to Harihareshwar Cab", "Pune to Harihareshwar Taxi"],
  ["Cab from Pune to Harihareshwar", "Taxi from Pune to Harihareshwar"],
  ["Pune to Harihareshwar Cab Service", "Pune to Harihareshwar Taxi Fare"],
  ["Pune to Harihareshwar One Way Cab", "Pune to Harihareshwar Round Trip Taxi"],
  ["Pune to Harihareshwar Cab Booking", "Cheap Pune to Harihareshwar Cab"],
  ["Best Pune to Harihareshwar Taxi", "Sedan Pune to Harihareshwar Cab"],
  ["SUV Pune to Harihareshwar Taxi", "Innova Pune to Harihareshwar Cab"],
  ["Beach Cab Pune Harihareshwar", "Harihareshwar Cab from Pune"],
  ["Pune to Harihareshwar Tour Package", "Pune to Harihareshwar Travel Package"],
  ["Pune to Harihareshwar Online Cab Booking", "Pune to Harihareshwar Door to Door Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Harihareshwar Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Harihareshwar cab transportation for families, tourists, pilgrims, couples, and beach vacation travelers."
    },
    {
        WhyChooseheading: "Perfect for Beach and Temple Tourism",
        WhyChoosedescription: "Harihareshwar is famous for its pristine beaches, ancient temples, scenic coastline, and peaceful atmosphere, making it a popular destination for relaxation and spiritual visits."
    },
    {
        WhyChooseheading: "Ideal for Weekend Getaways",
        WhyChoosedescription: "Whether planning a family holiday, beach vacation, temple visit, or short Konkan trip, we offer flexible travel options for every traveler."
    },
    {
        WhyChooseheading: "Wide Selection of Comfortable Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your group size and travel requirements."
    },
    {
        WhyChooseheading: "Cover Major Attractions Around Harihareshwar",
        WhyChoosedescription: "Travelers can visit Harihareshwar Temple, Harihareshwar Beach, Kalbhairav Temple, Shrivardhan Beach, Diveagar Beach, and nearby coastal attractions."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding locations."
    },
    {
        WhyChooseheading: "Safe Travel Through Scenic Konkan Routes",
        WhyChoosedescription: "Our experienced drivers ensure smooth and secure travel while allowing passengers to enjoy the beautiful coastal and ghat landscapes."
    },
    {
        WhyChooseheading: "Suitable for Families, Couples, and Groups",
        WhyChoosedescription: "Rising Cab Service caters to family vacations, honeymoon trips, pilgrimage tours, beach holidays, and group outings."
    }
]
};

const faqData = [
    {
        question: "Why is Harihareshwar a popular destination from Pune?",
        answer: "Harihareshwar is known for its ancient Shiva temple, beautiful beaches, coastal scenery, and peaceful atmosphere."
    },
    {
        question: "Can I book a one-way cab from Pune to Harihareshwar?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which attractions can be visited during a Harihareshwar trip?",
        answer: "Popular attractions include Harihareshwar Temple, Kalbhairav Temple, Harihareshwar Beach, Shrivardhan Beach, Diveagar Beach, and nearby Konkan destinations."
    },
    {
        question: "Which vehicle is suitable for a family trip to Harihareshwar?",
        answer: "Ertiga and Innova Crysta are among the most preferred options because they provide excellent comfort and luggage space."
    },
    {
        question: "Do you provide Tempo Travellers for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, and tourist groups."
    },
    {
        question: "Can Harihareshwar and Diveagar be covered in one trip?",
        answer: "Yes, customized itineraries can include Harihareshwar, Diveagar, Shrivardhan, and other nearby coastal destinations."
    },
    {
        question: "Are weekend holiday packages available?",
        answer: "Yes, customers can choose weekend getaway packages, overnight stays, and multi-day Konkan tours."
    },
    {
        question: "Can temple darshan and beach sightseeing be combined?",
        answer: "Yes, travel plans can include both religious visits and coastal sightseeing attractions."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Harihareshwar Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ketan Joshi",
        feedback:
            "Our Harihareshwar beach vacation was wonderfully organized. The vehicle was comfortable, the coastal drive was scenic, and the entire trip was enjoyable from start to finish.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Pooja Bendre",
        feedback:
            "We visited Harihareshwar, Shrivardhan, and Diveagar during our family holiday. The journey was smooth, the cab was spacious, and the overall travel experience exceeded expectations.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Harihareshwar Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-harihareshwar-cab.jpg",
"description": "Book Pune to Harihareshwar Cab Service with Rising Cab Service for safe and comfortable beach and temple travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family trips and weekend getaways.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-harihareshwar-cab"
}
};








    return (
        <div>

<Helmet>
  <title>Pune to Harihareshwar Cab Service | Beach & Temple Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Harihareshwar Cab Service for safe and comfortable beach and temple travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to harihareshwar cab, pune to harihareshwar taxi, cab from pune to harihareshwar, taxi from pune to harihareshwar, pune to harihareshwar cab service, pune to harihareshwar taxi fare, pune to harihareshwar one way cab, pune to harihareshwar round trip taxi, pune to harihareshwar cab booking, cheap pune to harihareshwar cab, best pune to harihareshwar taxi, beach cab pune harihareshwar"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>

            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoharihareshwarcab;